import React from 'react'
import { useFormikContext } from 'formik'
import { cloneDeep } from 'lodash'

import { FormGroupBootstrap, MdMath } from '../components'
import { ATTR, SoluzioniFactory } from './MultipleSoluzioniForm'
import { FormValuesMul as FormValues } from './MultipleSoluzioniForm'


const defaultValueSoluzioniSceltaMultipla = (count: number) => {
  return {
    testo_risposta: "",
    ordine: count,
    corretto: false,
  } as FormValues["problema"]["soluzioni_scelta_multipla"][0]
}

const idxToFormSoluzioniSceltaMultipla = (idx: number, attr_: ATTR) => {
  const attr = attr_ as "soluzioni_scelta_multipla";
  const build_name = (idx: number, name: string) => `problema.${attr}[${idx}].${name}`
  const formik = useFormikContext();
  const { setFieldValue } = formik;
  const values = formik.values as FormValues;

  return (
    <div className="card my-2">
      <div className="card-body">
        <button type="button" onClick={() => {
          const arrcopy = cloneDeep(values.problema[attr]);
          arrcopy.splice(idx, 1)
          setFieldValue("problema.${attr}", arrcopy)
        }}
          className="ml-auto btn btn-danger my-2"
        >
          <i className="fa fa-times" />
        </button>

        <FormGroupBootstrap
          name={build_name(idx, "testo_risposta")}
          help_text={"La risposta vera e propria per questa scelta"}
          type="text"
        />
        <div className="text-center">
          <MdMath source={values.problema[attr][idx].testo_risposta || ""} />
        </div>
        <FormGroupBootstrap
          name={build_name(idx, "ordine")} type="number" step={1}
          help_text={"Un numero per ordinare le risposte quando compaiono nel testo."}
        />
        <FormGroupBootstrap
          name={build_name(idx, "corretto")}
          help_text={"Questa è la risposta corretta? Seleziona una sola risposta corretta."}
          type="checkbox"
        />
      </div>
    </div>
  )
}



const RisposteMultipleForm = SoluzioniFactory("soluzioni_scelta_multipla", defaultValueSoluzioniSceltaMultipla, idxToFormSoluzioniSceltaMultipla)

export default RisposteMultipleForm;
